export default {
  storeNamespace: 'renting',
  authFeature: 'renting',
  newRouteName: "RentingNew",
  useNewModal: true,
  formComponentName: 'RentingForm',
  customSubmit: true,
  fields: [
    {
      name: 'products',
      label: "Produits",
      type: 'group_repeater',
      inForm: true,
      fields: [{
        name: 'product_id',
        label: "Produit",
        type: 'chosen',
        inForm: true,
      },
      {
        name: 'quantity',
        label: "Quantité",
        type: 'number',
        inForm: true,
      },
      ]
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/RentingAddProducts/config.js